<template>
	<div class="crumbs-sec clearfix">
		<label class="fl">当前位置：</label>
		<ul class="clearfix">
			<li class="fl" v-for="(crumbsModel,index) in crumbs" :key="index">
				<span  v-if="index < crumbs.length-1">
					<router-link v-if="crumbsModel.path != ''||crumbsModel.path != null" :to="crumbsModel.path">{{crumbsModel.name}}</router-link>
					<a v-else href="javascript:;">{{crumbsModel.name}}</a>
					<i class="iconfont">&#xe63f;</i>
				</span>
				<span v-else>
					<a href="javascript:void(0);">{{crumbsModel.name}}</a>
				</span>
			</li>
		</ul>
	</div>
</template>
<script>
export default{
	props:{
		crumbs:{
			// type:Object
		}
	},
	data(){
		return{
			pathUrl:''
		}
	},
	created(){
		this.pathUrl = this.crumbs.path
	},
	methods:{
		pathU(){
			return ''
		}
	}
}
</script>
<style type="text/css" scoped="scoped">
    .crumbs-sec{
        width: 1200px;
        margin:0 auto;
        color: #999999;
        padding: 10px 0 9px;
        font-size: 12px;
    }
    .crumbs-sec *{
        font-size: 12px;
    }
    .crumbs-sec a{
        color: #999;
    }
    .crumbs-sec a:hover{
        color: #7a7a7a;
    }
    .crumbs-sec i{
        margin: 0 5px;
    }
</style>